import { en } from './en';
import { ru } from './ru';
import { ptBR } from './pt-BR';
import { it } from './it';
import { sk } from './sk';
export const localization = {
    en,
    ru,
    ['pt-BR']: ptBR,
    it,
    sk,
};
